import axios from '@/axiosr8'

var AssetsProvider = function () {
  return {
    async getAssets () {
      let result = await axios.get('assets/')
      return result.data
    },
    async getToken (asset) {
      let result = await axios.get('assets/' + btoa(asset.UniqueId) + '/token')
      return result.data
    }
  }
}

export default new AssetsProvider()



// WEBPACK FOOTER //
// ./src/providers/AssetsProvider.js